import { asMessages } from '@core/Utils/Intl/AsMessages';

export const scope = 'containers.component.adminFee';

const definition = asMessages(scope, {
  ecom: '£99',
  d2c: '£49',
  pdpText: 'Plus {fee} admin fee',
  tooltipText:
    'We charge an admin fee, which covers processing costs, including documentation, preparing your car, and managing all necessary paperwork',
} as const);

export const adminFeeMessages = definition.messages;
export const defaultAdminFeeMessages = definition.defaultMessages;
export type AdminFeeMessages = typeof definition.defaultMessages;
